import { DataPackGroup } from '../../app/models/dataPackGroup.model';
import { DataPackValue } from '../../app/models/dataPackValue.model';

import { DataPackLine } from './dataPackLine.model';
import { PaginatedResult } from './paginatedResult.model';
import { DataPackUserManagerModel } from './data.manager.model';

/**
 * @author Wesley Mascarenhas
 * @version $Id: dataPackCompanyDetail.model.ts 54447 2017-07-26 23:34:29Z eduardo.s.neto $
 */
export class VoiceCompanyDetail {

  public franchiseAvailableVoice: DataPackValue;
  public franchiseAvailableData: DataPackValue;
  public franchiseConsumptionContracted: DataPackValue;
  public franchiseConsumptionConsumed: DataPackValue;
  public voiceFranchiseConsumptionContracted: DataPackValue;
  public totalExtraPack: DataPackValue;
  public totalBonus: DataPackValue;
  public totalBis: DataPackValue;
  public totalDataPackages: DataPackValue;
  public expirationDateBis: string;
  public groupList: Array<DataPackGroup>;
  public managersList: Array<DataPackUserManagerModel>;
  public percentageConsumedFranchise: string;
  public filterLines: Array<DataPackLine>;
  public recordCount: number;
  public pageTotal:number
  private paginationSearch: Map<number, PaginatedResult>;
  public hasOverBalanceMonetaryVoice:boolean;
  public hasHibridService:boolean;
    
  public constructor() {

  }
}


// WEBPACK FOOTER //
// ./src/app/models/voiceCompanyDetail.model.ts